import React, { useState } from 'react';
import { Book } from '@phosphor-icons/react';
import { SettingsLine } from './SettingsLine';
import { Select } from '../../../shared/components/form/Select';

interface ReadingSettingsProps {
  profile: {
    first_name: string;
    last_name: string;
    preferred_bible: string;
  };
  saving: boolean;
  setProfile: (profile: any) => void;
  updateProfile: (profile: any) => Promise<void>;
}

export function ReadingSettings({ profile, saving, setProfile, updateProfile }: ReadingSettingsProps) {
  const [localSaving, setLocalSaving] = useState(false);

  const bibleVersions = [
    { value: 'en-kjv', label: 'King James Version' },
    { value: 'en-web', label: 'World English Bible' },
    { value: 'en-bbe', label: 'Basic Bible in English' },
    { value: 'en-asv', label: 'American Standard Version' },
  ];

  const selectedVersion = bibleVersions.find(v => v.value === profile.preferred_bible) || bibleVersions[0];

  const handleVersionChange = async (value: string) => {
    try {
      setLocalSaving(true);
      // Update local state immediately
      setProfile({ ...profile, preferred_bible: value });
      // Save to backend
      await updateProfile({ preferred_bible: value });
    } catch (error) {
      // Revert on error
      setProfile({ ...profile });
      console.error('Failed to update Bible version:', error);
    } finally {
      setLocalSaving(false);
    }
  };

  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-wider text-[#361e06] mb-4">Reading Settings</h3>
      
      <div>
        <SettingsLine 
          label="Preferred Bible Version"
          icon={Book}
          isLast={true}
        >
          <Select
            value={selectedVersion.value}
            onChange={handleVersionChange}
            options={bibleVersions}
            isDisabled={saving || localSaving}
          />
        </SettingsLine>
      </div>
    </div>
  );
} 